{
  "loading": "載入中…",
  "loadError": "無法載入活動資訊，請稍後再試。",
  "directory": {
    "title": "活動",
    "description": "研討會、課程與工作坊等活動資訊。競賽請至「競賽」頁面。",
    "empty": "目前沒有公開的活動。"
  },
  "type": {
    "conference": "研討會",
    "course": "課程",
    "workshop": "工作坊",
    "seminar": "座談會",
    "exhibition": "展覽",
    "community_event": "社群活動"
  },
  "detail": {
    "date": "日期",
    "location": "地點",
    "organizer": "主辦單位",
    "registerCta": "前往官方報名",
    "officialCta": "官方網站",
    "registrationNotice": "報名、付款與宴會資格以官方 TAAI 報名系統為準，本頁僅提供補充服務資訊。",
    "shuttleCta": "免費接駁車線上預約"
  },
  "shuttle": {
    "title": "接駁車時刻表",
    "direction": {
      "to_venue": "前往會場",
      "return": "返程"
    },
    "depart": "發車",
    "arrive": "抵達",
    "reserve": "預約座位",
    "waitlistJoin": "加入候補",
    "signInToReserve": "登入後預約",
    "reserved": "已送出，請至「我的接駁車」查看",
    "availability": {
      "available": "尚有座位",
      "few": "座位不多",
      "full": "已額滿，可候補",
      "unavailable": "尚未開放"
    },
    "myLink": "我的接駁車",
    "boarding": "上車說明",
    "reserveError": "無法完成預約，請稍後再試。",
    "reason": {
      "already_booked": "你在該日期與方向已有預約或候補。",
      "booking_closed": "此班次已截止預約。",
      "slot_closed": "此班次尚未開放預約。",
      "email_unverified": "請先驗證 Email。",
      "idempotency_mismatch": "請重新整理頁面後再試。",
      "rider_profile_required": "請先填寫乘車聯絡資料。"
    },
    "notice": "接駁車免費。只要 Email 就能預約（不必建立帳號或密碼），也可以登入後預約。每個方向每天一次預約，可含本人與最多 3 位同行者；班次額滿可加入候補，有人取消時依序自動遞補。預約與取消於發車前 12 小時截止。",
    "reservedButton": "已預約",
    "reservedOk": "已預約座位成功",
    "onWaitlist": "已加入候補",
    "waitlistedOk": "已加入候補，第 {{position}} 位",
    "reserving": "預約中…",
    "lockedByOther": "此日期這個方向你已預約其他時段。",
    "manage": "查看憑證或取消",
    "cancel": "取消預約",
    "cancelConfirm": "確定要取消這筆預約嗎？",
    "cancelFailed": "無法取消，可能已超過截止時間。",
    "cancelling": "取消中…",
    "daysLabel": "服務日期",
    "signInWhy": "Email 預約：我們會寄一封連結，開啟後才保留座位。登入後可在同一處管理所有座位。",
    "summary": "免費 · 只要 Email 或登入 · 發車前 12 小時截止",
    "rulesTitle": "預約規則",
    "tzNote": "台灣時間 (UTC+08:00)",
    "lockedDetail": "你在此方向已預約 {{time}} 的班次。",
    "from": "出發",
    "to": "到達",
    "code": "班次",
    "codeLegend": "班次像高鐵車次，三位數字依序代表日期、出發、到達。日期：1 = 11/20，2 = 11/21。站別：1 = 臺北大學站，2 = 板橋高鐵站，3 = 會場。例如 113 是第一天臺北大學站往會場，132 是第一天會場往板橋高鐵站。"
  },
  "my": {
    "title": "我的接駁車",
    "signIn": "請先登入",
    "empty": "你目前沒有接駁車預約。",
    "browse": "查看時刻表",
    "confirmed": "已確認座位",
    "waitlisted": "候補中（第 {{position}} 位）",
    "cancel": "取消預約",
    "cancelConfirm": "確定要取消這個預約嗎？",
    "cancelClosed": "已超過取消期限（發車前 12 小時），如需協助請聯絡主辦單位。",
    "cancelError": "取消失敗，請稍後再試。",
    "cutoffNotice": "發車前 12 小時截止取消。候補遞補成功時會以 Email 通知。",
    "qrLabel": "乘車 QR（{{code}}）",
    "qrHint": "上車時請向工作人員出示此 QR；請勿轉傳。",
    "addToCalendar": "加入行事曆",
    "reminderLabel": "發車前 24 小時內寄 Email 提醒我",
    "reminderHint": "選填。每趟已確認的行程寄一次到你已驗證的 Email，不含乘車 QR。可隨時在這裡關閉。",
    "reminderError": "無法儲存提醒設定。",
    "closesLabel": "取消預約",
    "companionOf": "同行者：{{name}}"
  },
  "staff": {
    "title": "接駁車驗票",
    "denied": "你沒有此活動的工作人員權限。",
    "slot": "目前班次",
    "credential": "乘車憑證（掃描或貼上）",
    "scan": "驗票",
    "error": "驗票失敗，請重試。",
    "result": {
      "success": "驗票成功",
      "duplicate": "重複掃描（已驗過）",
      "wrong_slot": "班次不符",
      "invalid": "無效憑證",
      "not_confirmed": "此預約未確認（候補或已取消）"
    },
    "cameraOn": "開啟相機掃描",
    "cameraOff": "關閉相機",
    "cameraUnavailable": "此瀏覽器或裝置無法使用相機掃描，請改用貼上憑證。",
    "provisional": "已離線暫存（待同步，結果以伺服器為準）",
    "queued": "待同步的離線掃描：{{count}}",
    "syncNow": "立即同步",
    "synced": "已同步 {{total}} 筆；其中 {{conflicts}} 筆非成功（重複、班次不符等）。",
    "manual": "需要人工處理",
    "pendingSync": "已暫存在此裝置，尚未經伺服器確認",
    "sessionCount": "本次已驗票",
    "successLabel": "驗票成功"
  },
  "notices": {
    "title": "最新公告",
    "severity": {
      "info": "一般",
      "important": "重要",
      "critical": "緊急"
    }
  },
  "services": {
    "title": "現場服務",
    "meals": "餐飲與宴會",
    "help": "客服與協助",
    "my": "我的接駁車",
    "admin": "主辦方後台",
    "volunteer": "志工班表",
    "presenter": "海報與講者",
    "ops": "營運管理",
    "mineTitle": "我的服務",
    "staffTitle": "工作人員與參與者",
    "checkin": "接駁車驗票",
    "roster": "乘客名單"
  },
  "meals": {
    "title": "餐飲與宴會回覆",
    "notice": "請告知午餐出席與飲食需求。備註僅供主辦單位處理餐飲，並以加密儲存，不會顯示給工作人員驗票畫面。",
    "closed": "餐飲回覆已截止（2026/11/16 23:59 UTC+08:00）。",
    "attending": "我會出席午餐",
    "dietary": "飲食類別",
    "note": "補充說明（選填，最多 200 字）",
    "banquet": "宴會回覆",
    "banquetNotice": "此回覆僅供主辦單位估算人數，並非宴會資格或付款證明；宴會資格以官方 TAAI 報名為準。",
    "banquetOptions": {
      "yes": "我會出席宴會",
      "no": "我不出席宴會"
    },
    "save": "儲存",
    "saved": "已儲存。",
    "saveError": "儲存失敗，請稍後再試。",
    "codes": {
      "none": "無特殊需求",
      "vegetarian": "蛋奶素",
      "vegan": "純素",
      "halal": "清真",
      "no_beef": "不吃牛",
      "no_pork": "不吃豬",
      "seafood_allergy": "海鮮過敏",
      "nut_allergy": "堅果過敏",
      "other": "其他（請於備註說明）"
    }
  },
  "help": {
    "title": "客服與協助",
    "emergency": "如遇人身安全緊急狀況，請立即撥打 119 或 110，並通知現場工作人員。",
    "contact": "一般問題可於下方送出案件，或參考官方網站：",
    "signIn": "登入後送出案件",
    "category": "類別",
    "categories": {
      "transport": "交通接駁",
      "meal": "餐飲",
      "registration": "報名",
      "accessibility": "無障礙協助",
      "lost_property": "遺失物",
      "other": "其他"
    },
    "subject": "主旨",
    "body": "說明",
    "urgent": "緊急",
    "urgentTag": "[緊急]",
    "submit": "送出案件",
    "sent": "案件已送出，主辦單位會盡快處理。",
    "error": "送出失敗，請稍後再試。",
    "mine": "我的案件",
    "status": {
      "new": "新案件",
      "in_progress": "處理中",
      "resolved": "已解決",
      "closed": "已結案"
    }
  },
  "admin": {
    "title": "主辦方後台",
    "checkinLink": "前往接駁車驗票",
    "provenance": "資料來源：本平台資料庫；更新時間 {{time}}（UTC+08:00）。已預約、候補、已驗票分開計算。",
    "shuttle": "接駁車",
    "capacity": "容量",
    "confirmed": "已預約",
    "waitlisted": "候補",
    "checkedIn": "已驗票",
    "meals": "餐飲與宴會（僅統計）",
    "banquetCounts": "宴會回覆：出席 {{yes}}、不出席 {{no}}",
    "openTickets": "未結案件：{{count}}",
    "notices": "公告",
    "severity": "類型",
    "titleZh": "標題（中文）",
    "titleEn": "標題（英文）",
    "bodyZh": "內容（中文）",
    "bodyEn": "內容（英文）",
    "publish": "發布公告",
    "publishError": "發布失敗。",
    "withdraw": "撤回",
    "tickets": "客服案件",
    "ticketStatus": "狀態",
    "rosterLink": "乘客名單",
    "tabs": {
      "label": "後台分頁",
      "overview": "總覽",
      "notices": "公告",
      "helpdesk": "服務台",
      "members": "成員"
    },
    "kpi": {
      "booked": "已預約座位",
      "waitlisted": "候補",
      "checkedIn": "已驗票",
      "trips": "班次"
    }
  },
  "volunteer": {
    "title": "我的志工班表",
    "empty": "目前沒有指派給你的班次。"
  },
  "presenter": {
    "title": "海報與講者服務",
    "posters": "我的海報與設備",
    "noPosters": "尚無指派給你的海報位置。",
    "item": "設備",
    "quantity": "數量",
    "request": "送出申請",
    "requestError": "申請失敗。",
    "items": {
      "power": "電源",
      "table": "桌子",
      "monitor": "螢幕",
      "easel": "海報架",
      "other": "其他"
    },
    "status": {
      "requested": "待審核",
      "approved": "已核准",
      "rejected": "未核准"
    },
    "upload": "簡報上傳",
    "notSpeaker": "你不在此活動的講者名單中。如有需要請聯絡主辦單位。",
    "uploadNotice": "僅接受 PDF 或 PPTX（30 MB 以內，最多 10 個檔案）。檔案上傳後先進入隔離審核，僅主辦單位可下載。",
    "file": "選擇檔案",
    "send": "上傳",
    "uploaded": "已上傳，待主辦單位審核。",
    "uploadError": "上傳失敗，請確認檔案類型與大小。",
    "reasons": {
      "file_type_not_allowed": "僅接受 PDF 或 PPTX。",
      "file_too_large": "檔案超過 30 MB。",
      "file_type_mismatch": "檔案內容與副檔名不符。",
      "too_many_files": "已達上傳數量上限。"
    },
    "fileStatus": {
      "pending_review": "待審核",
      "approved": "已核准",
      "rejected": "未核准"
    }
  },
  "ops": {
    "title": "營運管理",
    "back": "返回主辦方後台",
    "shifts": "志工排班",
    "shiftTitle": "班次名稱",
    "shiftLocation": "地點",
    "start": "開始",
    "end": "結束",
    "volunteerEmails": "志工 Email（以逗號或換行分隔）",
    "addShift": "新增班次",
    "error": "操作失敗。",
    "posters": "海報位置",
    "posterFormat": "每行一筆：位置代碼, 標題, 發表者 Email",
    "importPosters": "匯入官方海報配置",
    "posterError": "匯入失敗：位置重複或格式錯誤，整批未寫入。",
    "equipment": "設備申請",
    "approve": "核准",
    "reject": "拒絕",
    "speakers": "講者與簡報",
    "speakerEmails": "講者 Email（以逗號或換行分隔）",
    "addSpeakers": "加入講者",
    "quarantine": "系統沒有防毒引擎：檔案限 PDF 與 PPTX、驗證檔頭、一律先隔離，請下載後以本機防毒軟體檢查再核准。",
    "download": "下載",
    "emailPush": "公告 Email 推播",
    "emailNotice": "先預覽對象，確認後才會寄出；每位收件人只會收到一次。",
    "preview": "預覽收件對象",
    "previewSummary": "收件人 {{count}} 位（已寄過 {{done}} 位）。",
    "send": "確認並寄出",
    "sendConfirm": "確定寄給 {{count}} 位收件人？寄出後無法撤回。",
    "sendResult": "已寄出 {{sent}}、略過 {{skipped}}、失敗 {{failed}}。",
    "tabs": {
      "label": "營運分頁",
      "shifts": "志工班表",
      "posters": "海報與設備",
      "speakers": "講者檔案",
      "email": "公告 Email"
    }
  },
  "members": {
    "title": "活動成員",
    "help": "成員以已驗證的 Email 登入。可在對方註冊前先加入，註冊前顯示為「待註冊」。超級管理員永遠具備 owner 權限。",
    "email": "Email",
    "role": "角色",
    "add": "新增成員",
    "remove": "移除",
    "roleOf": "{{email}} 的角色",
    "confirmRemove": "確定將 {{email}} 從此活動移除？",
    "exists": "此 Email 已是成員。",
    "lastOwner": "最後一位 owner 不能被移除或降級，請先新增另一位 owner。",
    "error": "無法更新成員，請稍後再試。",
    "status": {
      "active": "已生效",
      "pending": "待註冊"
    },
    "roles": {
      "owner": "Owner（主辦）",
      "manager": "Manager（管理）",
      "scanner": "Scanner（驗票）",
      "viewer": "Viewer（檢視）"
    },
    "roleHelp": {
      "owner": "全部功能，含成員管理",
      "manager": "公告、Email 推播、餐飲匯出、服務單",
      "scanner": "驗票與乘客名單",
      "viewer": "僅檢視報表"
    }
  },
  "rider": {
    "title": "乘車聯絡資料",
    "privacy": "僅用於接駁異動與現場緊急聯絡。現場驗票人員會看到你的姓名、單位與職稱；行動電話只有活動 owner 可以查看（每次查看都留有紀錄）。行動電話加密儲存，全部資料於活動結束後 30 天自動刪除。",
    "realName": "真實姓名（必填）",
    "organization": "單位（選填）",
    "jobTitle": "職稱（選填）",
    "mobile": "行動電話（選填，供緊急異動聯絡）",
    "confirm": "我確認這是我的真實姓名，方便現場人員核對乘客名單。",
    "submit": "儲存並預約",
    "cancel": "取消",
    "error": "無法儲存。請確認姓名（2–60 字、需含文字）與行動電話格式後再試。"
  },
  "nav": {
    "back": "返回活動"
  },
  "summary": {
    "title": "我的行程摘要",
    "shuttle": "接駁車：已預約 {{confirmed}} 趟，候補 {{waitlisted}} 趟",
    "shuttleNone": "接駁車：尚未預約",
    "mealsPending": "餐飲與宴會：尚未回覆",
    "mealsDone": "餐飲與宴會：已回覆"
  },
  "roster": {
    "title": "乘客名單",
    "slot": "接駁時段",
    "name": "姓名",
    "organization": "單位",
    "jobTitle": "職稱",
    "status": "狀態",
    "checkedIn": "已驗票",
    "confirmed": "已預約",
    "waitlisted": "候補",
    "yes": "是",
    "no": "否",
    "empty": "這個時段目前沒有乘客。",
    "loadError": "無法載入名單。",
    "showPhones": "顯示緊急聯絡電話",
    "phonesNotice": "電話僅供緊急聯絡使用，每次顯示都會寫入稽核紀錄。",
    "phonesTitle": "緊急聯絡人",
    "phone": "行動電話",
    "noPhone": "未提供",
    "phonesError": "無法載入電話。",
    "summary": "已驗票 {{checked}} / {{total}} 人",
    "search": "搜尋姓名或單位",
    "filter": "狀態篩選",
    "all": "全部",
    "notCheckedIn": "未驗票",
    "checkedInOnly": "已驗票",
    "waitlistedOnly": "候補",
    "shown": "顯示 {{count}} 人"
  },
  "countdown": {
    "closesIn": "剩餘 {{time}}",
    "closed": "已截止",
    "dh": "{{d}} 天 {{h}} 小時",
    "hm": "{{h}} 小時 {{m}} 分",
    "m": "{{m}} 分"
  },
  "nextTrip": {
    "title": "下一班車",
    "departsIn": "距離發車 {{time}}",
    "departed": "即將發車"
  },
  "quick": {
    "toggle": "只用 Email 預約（免建立帳號）",
    "formLabel": "免登入預約",
    "intro": "不需要密碼。填寫姓名與 Email，我們會寄一封連結，開啟連結後才會保留座位。",
    "name": "真實姓名",
    "email": "電子郵件",
    "confirm": "我確認這是我的真實姓名，供上車核對使用。",
    "submit": "寄給我確認連結",
    "sending": "寄送中…",
    "cancel": "取消",
    "sent": "請到 {{email}} 收信，並於 30 分鐘內開啟連結以保留座位。目前尚未保留座位。",
    "error": "無法送出請求，請檢查資料後再試一次。",
    "slotClosed": "此班次已不開放預約。",
    "confirmTitle": "確認你的預約",
    "confirming": "確認中…",
    "done": "接駁車預約已確認，這台裝置也已為你登入。",
    "seat": "第 {{n}} 席",
    "you": "本人",
    "viewMine": "前往「我的接駁車」查看乘車 QR",
    "invalid": "此連結無效或已過期，請重新申請。",
    "requestAgain": "重新申請連結",
    "signInRequired": "此 Email 屬於需以一般方式登入的帳號。",
    "already_booked": "你在該日期與方向已有座位，因此未新增預約。",
    "booking_closed": "此班次已截止預約，因此未建立預約。",
    "slot_closed": "此班次未開放預約，因此未建立預約。",
    "booking_failed": "預約未能完成。"
  },
  "companions": {
    "add": "同行者一起預約",
    "hide": "收合同行者",
    "label": "同行者 {{n}} 真實姓名",
    "addOne": "新增同行者",
    "remove": "移除同行者 {{n}}",
    "hint": "最多 3 位同行者。每人各有自己的乘車 QR，也可以單獨取消。",
    "submit": "預約 {{count}} 個座位",
    "groupLabel": "同行者"
  },
  "shuttlePage": {
    "title": "{{event}} 免費接駁車線上預約",
    "intro": "選擇日期、去回程與班次。免費，一次最多 4 位。",
    "back": "回活動頁",
    "language": "語言"
  }
}
